import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { EDateFormat } from '@pc/common';
export type CalculationSymbolsDate = 'Add' | 'Subtract' | 'Multiply' | 'Divide';
@Injectable({ providedIn: 'root' })
export class PcDateUtils {
  private datepipe: DatePipe = new DatePipe('en-US');

  convertDateToString(date: Date, CheckNavigator: boolean): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    if (CheckNavigator) {
      return navigator.language.includes('en') ? `${month}/${day}/${year}` : `${day}/${month}/${year}`;
    } else {
      return `${day}/${month}/${year}`;
    }
  }

  setDateUTC(date: Date): Date {
    if (date) {
      const newDate = new Date(date.toString());
      const dateUTC = Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
      return new Date(dateUTC);
    }
    return date;
  }

  public toDate(date: unknown): string {
    if (!(date instanceof Date)) return '';
    return this.datepipe?.transform(date, EDateFormat.EUROPE) ?? '';
  }

  public getCalendarDateRangeString(dates: DateRange<Date> | null | undefined, isStart = true): string {
    const dateRange = dates as DateRange<Date>;
    if (dateRange?.start && dateRange?.end) {
      return isStart ? this.toDate(dateRange.start) : this.toDate(dateRange.end);
    }
    return '';
  }

  public getCalendarDateString(date: Date | null | undefined, isStart = true): string {
    if (isStart) {
      const dateVal = date as Date;
      return this.toDate(dateVal);
    } else {
      return '';
    }
  }
  public isValidDate(value: string | Date, isUSFormat = false): boolean {
    if (typeof value === 'string') {
      const parts = value.split('/');
      if (parts.length === 3) {
        let day, month, year;
        if (isUSFormat) {
          month = parseInt(parts[0], 10) - 1;
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
        } else {
          day = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1;
          year = parseInt(parts[2], 10);
        }

        const date = new Date(year, month, day);
        return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
      }
      return false;
    } else if (value instanceof Date) {
      return !isNaN(value.getTime());
    }
    return false;
  }

  getDatesDifferenceInDays(date1: Date, date2: Date): number {
    this.resetHoursToOriginalTime(date1, date2);
    return Math.round(Math.abs(date1.getTime() - date2.getTime()) / (1000 * 60 * 60 * 24));
  }

  resetHoursToOriginalTime(date1: Date, date2: Date): number {
    return date1.setHours(0, 0, 0, 0), date2.setHours(0, 0, 0, 0);
  }

  resetDataHours(date: Date): Date {
    date.setHours(0, 0, 0, 0);
    return date;
  }

  checkDateRangeValid(startDate: Date, endDate: Date, rangeInDays: number): boolean {
    const endDateRang = this.resetDataHours(new Date(endDate));
    const rangeStart = this.resetDataHours(new Date(startDate));
    const DateRang = this.resetDataHours(new Date(startDate));
    DateRang.setDate(rangeStart.getDate() + rangeInDays);
    return DateRang < endDateRang;
  }

  modifyDateByYears(number: number, symbol: CalculationSymbolsDate, currentDate: Date = new Date(Date.now())): Date {
    currentDate.setHours(0, 0, 0, 0);
    if (symbol === 'Add') {
      currentDate.setFullYear(currentDate.getFullYear() + number);
    } else if (symbol === 'Subtract') {
      currentDate.setFullYear(currentDate.getFullYear() - number);
    } else {
      throw new Error('Invalid value for addOrRemove. Use "Add" or "Subtract".');
    }
    return currentDate;
  }

  modifyDateByDays(number: number, symbol: CalculationSymbolsDate, currentDate: Date = new Date(Date.now())): Date {
    currentDate.setHours(0, 0, 0, 0);
    if (symbol === 'Add') {
      currentDate.setDate(currentDate.getDate() + number);
    } else if (symbol === 'Subtract') {
      currentDate.setDate(currentDate.getDate() - number);
    } else {
      throw new Error('Invalid value for addOrRemove. Use "Add" or "Subtract".');
    }
    return currentDate;
  }
}
